import React from 'react';
import { useCanCreatePoll } from '../../MessageComposer/hooks/useCanCreatePoll';
import { useMessageComposerController } from '../../MessageComposer/hooks/useMessageComposerController';
import { useMessageComposerContext, useTranslationContext } from '../../../context';
import clsx from 'clsx';
import { IconSend } from '../../Icons';
import { Prompt } from '../../Dialog';

export type PollCreationDialogControlsProps = {
  close: () => void;
};

export const PollCreationDialogControls = ({
  close,
}: PollCreationDialogControlsProps) => {
  const { t } = useTranslationContext('PollCreationDialogControls');
  const { handleSubmit: handleSubmitMessage } = useMessageComposerContext();
  const messageComposer = useMessageComposerController();
  const canCreatePoll = useCanCreatePoll();

  return (
    <Prompt.Footer>
      <Prompt.FooterControls>
        <Prompt.FooterControlsButtonSecondary
          className={clsx('str-chat__prompt__footer__controls-button--cancel')}
          onClick={() => {
            messageComposer.pollComposer.initState();
            close();
          }}
          type='button'
        >
          {t('Cancel')}
        </Prompt.FooterControlsButtonSecondary>
        <Prompt.FooterControlsButtonPrimary
          className={clsx('str-chat__prompt__footer__controls-button--submit')}
          disabled={!canCreatePoll}
          onClick={() => {
            messageComposer
              .createPoll()
              .then(() => handleSubmitMessage())
              .then(() => {
                messageComposer.pollComposer.initState();
                close();
              })
              .catch(console.error);
          }}
          type='submit'
        >
          <IconSend />
          {t('Send poll')}
        </Prompt.FooterControlsButtonPrimary>
      </Prompt.FooterControls>
    </Prompt.Footer>
  );
};
